import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to Voyara AI — Eclipse Group's intelligent travel platform."
        canonical="https://www.eclipsegroup.in/404"
        noIndex
      />
      <main className="relative z-10 min-h-screen flex items-center justify-center">
        <div className="text-center global-container max-w-[600px]">
          <div>
            <h1
              className="font-serif mb-6"
              style={{
                fontSize: 'clamp(5rem, 12vw, 10rem)',
                lineHeight: '1',
                letterSpacing: '-0.06em',
                background: 'linear-gradient(180deg, rgba(245,245,245,0.6) 0%, rgba(245,245,245,0.15) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              404
            </h1>

            <p className="text-secondary text-lg font-medium mb-4 tracking-tight">
              This route doesn't exist in our network.
            </p>
            <p className="text-[#f5f5f5]/55 text-sm font-light mb-12 max-w-md mx-auto">
              The page you're looking for may have been moved or doesn't exist.
              Let's get you back to familiar coordinates.
            </p>

            <Link
              to="/"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-white/10 border border-white/20 text-primary text-[13px] font-bold tracking-[0.15em] uppercase hover:bg-white/15 hover:border-white/30 transition-all duration-500 group"
            >
              <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
              Return Home
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
